<div style="display: flex; justify-content: center; width:100%; padding-top: 20%;">
    <mat-spinner></mat-spinner>
</div>
<div style="display: flex; justify-content: center; padding-top: 1%;">
    Logging In
</div>
<div *ngIf="showMessage" style="display: flex; justify-content: center;">
    Login taking longer than expected. Please wait...
</div>